export default __webpack_public_path__ + "static/doctor-3-b91ec8970456342fdcdae7075c41b01d.png";